import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import CreateBloc from './Blocs/CreateBloc'
import DatePicker from '../../../../../helpers/ui/DatePicker'

class ContentView extends Component {
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            is_revisi: this.queryParams.get('is_revisi'),
            revisi_pegawai_uuid: this.queryParams.get('pegawai_uuid'),
            period_revision_uuid: this.queryParams.get('period_revision_uuid')
        }

    }
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        {
                                            this.state.is_revisi == 1 ?
                                                <Link to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid}>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                                :
                                                <Link to={`/izinpegawai/dinas.html${(this.currentRoleId == 1 ? '?detail_pegawai&uuid=' + this.peg_uuid : '')}`}>
                                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                                </Link>
                                        }
                                    </div>
                                    <CardTitle>Pengajuan Perjalanan Dinas</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <CreateView isSubmit={true} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}
var reformatSignatory = function (data) {
    return data.map(function (item) {
        var newObj = {};
        newObj["label"] = item.signatories_official_nip + " - " + item.signatories_official_name;
        newObj["value"] = item.signatories_official_nip;
        return newObj;
    });
};
class CreateView extends Component {
    queryParams = new URLSearchParams(window.location.search)


    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    // peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "") 
    // : (this.employeeSeleted != null ? this.employeeSeleted : "")
    peg_detail = this.userdata

    source
    createBloc = new CreateBloc();
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            employeeOption: [],
            options: [],
            domicile: 1,
            regionOption: [],
            cityOption: [],
            provinceOption: [],
            signatoriesOption: [],
            participant: [],
            oversea: 1,
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc'
                }
            },
            is_revisi: this.queryParams.get('is_revisi'),
            revisi_pegawai_uuid: this.queryParams.get('pegawai_uuid'),
            period_revision_uuid: this.queryParams.get('period_revision_uuid')
        }

    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.employeeFilter.filter_value = value

        this.timer = setTimeout(() => this.loadEmployeeList(), 800);
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                revisi_pegawai_uuid: this.state.revisi_pegawai_uuid,
                is_revisi: this.state.is_revisi,
                period_revision_uuid: this.state.period_revision_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.createBloc.fetchCreate(dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    getCity = (province_uuid) => {
        this.indexBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })
        const query = {
            is_local: 1,
            type: 3,
            parent_uuid: province_uuid
        }
        this.indexBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = {
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.indexBloc.fetchRegionProvince(query, this.source.token)
    }


    loadEmployeeList = async () => {
        let offset = (this.state.employeeFilter.page_number - 1) * this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchEmployeeList(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.indexBloc.fetchRegion(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadEmployeeList()
        this.loadProvince()
        this.loadRegion()
    }

    handleDelete = (index, e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state.options));
        stateClone.splice(index, 1);
        this.setState({ options: stateClone });
        e.preventDefault();
    }

    handleClick = (e) => {
        let stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.options.push(this.defaultOption);
        this.setState({ options: stateClone.options });
        e.preventDefault();
    }

    customRow = (options) => {
        const listItems = options.map((cusRow, index) => (
            <Row className="mb-4">
                <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label"></Label>
                <Col sm={5}>
                    <Select
                        name={`official_travel_participant_employee_uuid[${index + 1}]`}
                        placeholder="Pilih Partisipan"
                        errorMessage="Silahkan Pilih Partisipan"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        options={this.state.employeeOption?.result}
                        optionLabel="employee_opt_label"
                        optionValue="employee_uuid"
                        onInputChange={value => this.handleSelectInputChange(value)}
                    />
                </Col>
                <Col sm={1}>
                    <Button color="danger" type="button" title="Hapus participant" onClick={(e) => this.handleDelete(index, e)}>
                        <i className="uil-minus"></i>
                    </Button>
                </Col>
            </Row>
        )
        );
        return (
            listItems
        )
    }



    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.employeeListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.createBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: reformatSignatory(result.data.response.result) })
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchSignatories()

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount = () => {
        this.indexBloc.employeeListChannel?.unsubscribe()
    }

    render() {
        let { options } = this.state;
        let { result } = this.state.employeeOption
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Nomor Surat Tugas<span className="text-danger">*</span>
                        </Label>
                        <Col md="4">
                            <AvField
                                type="text"
                                placeholder="Nomor Surat Tugas"
                                errorMessage="Masukkan Nomor Surat Tugas"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                name="official_travel_number" />
                        </Col>
                        <Col md="4">
                            <DatePicker
                                name="official_travel_number_date"
                                isWeekday={true}
                                dateFormat="dd/MM/yyyy"
                                placeholder="Tanggal Surat Tugas"
                                errorMessage="Masukan Tanggal Surat Tugas"
                                validate={{ required: { value: true } }}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Tanggal Mulai Dinas <span className="text-danger">*</span>
                        </Label>
                        <Col md="2">
                            {/* <AvField
                                name="official_travel_date"
                                placeholder="Tanggal Perjalanan Dinas"
                                type="date"
                                errorMessage="Masukkan Tanggal Perjalanan Dinas"
                                className="form-control"
                                value={this.props.date}
                                validate={{ required: { value: true } }}
                            /> */}
                            <DatePicker
                                name="official_travel_date"
                                isWeekday={false}
                                dateFormat="dd/MM/yyyy"
                                placeholder="Tanggal Mulai Perjalanan Dinas"
                                errorMessage="Masukan Tanggal Mulai Perjalanan Dinas"
                                validate={{ required: { value: true } }}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Tanggal Selesai Dinas <span className="text-danger">*</span>
                        </Label>
                        <Col md="2">
                            {/* <AvField
                                name="official_travel_end_date"
                                placeholder="Tanggal Selesai Perjalanan Dinas"
                                type="date"
                                errorMessage="Masukkan Tanggal Selesai Perjalanan Dinas"
                                className="form-control"
                                value={this.props.date}
                                validate={{ required: { value: true } }}
                            /> */}
                            <DatePicker
                                name="official_travel_end_date"
                                isWeekday={false}
                                dateFormat="dd/MM/yyyy"
                                placeholder="Tanggal Selesai Perjalanan Dinas"
                                errorMessage="Masukan Tanggal Perjalanan Dinas"
                                validate={{ required: { value: true } }}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Tempat Dinas <span className="text-danger">*</span>
                        </Label>
                        <Col md="3">
                            <Select
                                name="official_travel_oversea"
                                placeholder="Tempat Dinas"
                                errorMessage="Masukkan Tempat Dinas"
                                validate={{ required: { value: true } }}
                                options={[
                                    { value: 1, label: 'Dalam Negeri' },
                                    { value: 2, label: 'Luar Negeri' }
                                ]}
                                onChange={opt => this.setState({ oversea: opt.value })}
                                isSearchable={true}
                                defaultValue={this.state.oversea}
                            />
                        </Col>
                    </Row>

                    {this.state.oversea == 1 ?
                        <Fragment>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label"
                                >
                                </Label>
                                <Col md="3">
                                    <AvField
                                        type="hidden"
                                        name="official_travel_country_uuid"
                                        value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid}
                                    />
                                    <Select
                                        name="official_travel_domicile"
                                        placeholder="Tempat Dinas"
                                        errorMessage="Masukkan Tempat Dinas"
                                        validate={{ required: { value: true } }}
                                        options={[
                                            { value: 1, label: 'Dalam Kota' },
                                            { value: 2, label: 'Luar Kota' }
                                        ]}
                                        onChange={opt => this.setState({ domicile: opt.value })}
                                        isSearchable={true}
                                        defaultValue={this.state.domicile}
                                    />
                                </Col>
                                {
                                    this.state.domicile == 1 &&
                                    <Col md={3}>
                                        <Select
                                            name="official_travel_allowance_type"
                                            placeholder="Kategori"
                                            errorMessage="Masukkan Kategori"
                                            validate={{ required: { value: true } }}
                                            options={[
                                                { value: 0, label: 'Kurang dari 8 jam' },
                                                { value: 1, label: 'Lebih dari 8 jam' }
                                            ]}
                                            isSearchable={true}
                                        />
                                    </Col>
                                }
                            </Row>

                            {this.state.domicile == 2 &&
                                <Fragment>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Provinsi <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="3">
                                            <Select
                                                name="official_travel_province_uuid"
                                                errorMessage="Pilih Provinsi"
                                                // onChange={this.handleIdentitySelectProvince}
                                                onChange={value => this.getCity(value.region_uuid)}
                                                options={this.state.provinceOption}
                                                optionLabel="region_name"
                                                optionValue="region_uuid"
                                                validate={{ required: { value: true } }}
                                                placeholder="Pilih Provinsi"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-2 col-form-label"
                                        >
                                            Kota <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="3">
                                            <Select
                                                name="official_travel_city_uuid"
                                                errorMessage="Pilih Kota Dinas"
                                                options={this.state.cityOption}
                                                optionLabel="region_name"
                                                optionValue="region_uuid"
                                                validate={{ required: { value: true } }}
                                                placeholder="Pilih Kota Lahir"
                                            />
                                        </Col>
                                    </Row>
                                </Fragment>
                            }
                        </Fragment>
                        :
                        <Fragment>
                            <Row className="mb-3">
                                <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                <Col md="3">
                                    <Select
                                        name="official_travel_country_uuid"
                                        errorMessage="Pilih Negara"
                                        options={this.state.regionOption}
                                        optionValue="region_uuid"
                                        optionLabel="region_name"
                                        placeholder="Pilih Negara"
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>
                        </Fragment>
                    }

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Tujuan <span className="text-danger">*</span>
                        </Label>
                        <Col md="6">
                            <AvField
                                name="official_travel_destination"
                                placeholder="Tujuan Perjalanan Dinas"
                                type="textarea"
                                rows="5"
                                errorMessage="Masukkan Tujuan Perjalanan Dinas"
                                className="form-control"
                                validate={{ required: { value: true } }}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Keterangan
                        </Label>
                        <Col md="6">
                            <AvField
                                name="official_travel_description"
                                placeholder="Keterangan Perjalanan Dinas"
                                type="textarea"
                                rows="5"
                                className="form-control"
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Label className="col-md-2 col-form-label">
                            Upload ST
                        </Label>
                        <Col md="6">
                            <FileInput
                                name="file"
                            // validate={{ required: { value: true } }}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label">Partisipan  <span className="text-danger">*</span></Label>
                        <Col sm={5}>
                            {/* <AvField
                                name="official_travel_participant_employee_uuid[0]"
                                type="hidden"
                                value={this.peg_detail.employee_uuid}
                            />
                            <AvField
                                name="view_name"
                                type="text"
                                className="form-control"
                                readOnly={true}
                                value={this.peg_detail.employee_name != null ? this.peg_detail.employee_name : '' + ' - ' + this.peg_detail.employee_current_position_name != null ? this.peg_detail.employee_current_position_name : ''}
                            /> */}
                            <Select
                                name="official_travel_participant_employee_uuid[0]"
                                placeholder="Pilih Partisipan"
                                errorMessage="Silahkan Pilih Partisipan"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                options={this.state.employeeOption?.result}
                                optionLabel="employee_opt_label"
                                optionValue="employee_uuid"
                                onInputChange={value => this.handleSelectInputChange(value)}
                            />
                        </Col>
                        <Col sm={1}>
                            <Button color="primary" type="button" title="Tambah Partisipan" onClick={e => this.handleClick(e)}>
                                <i className="uil-plus"></i>
                            </Button>
                        </Col>
                    </Row>

                    {this.customRow(options)}

                    <Row className="mb-3">
                        <Label
                            className="col-md-2 col-form-label"
                        >
                            Pejabat Penandatangan <span className="text-danger">*</span>
                        </Label>
                        <Col md="6">
                            <Select
                                name="official_travel_assignment_nip"
                                placeholder="Pilih Pejabat Penandatangan"
                                errorMessage="Silahkan Pilih Pejabat Penandatangan"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                options={this.state.signatoriesOption}
                            />
                        </Col>
                    </Row>

                    {this.props.isSubmit == true &&
                        <Row className="mb-3">
                            <Col md="2"></Col>
                            <Col md="9">
                                {
                                    this.state.is_revisi == 1 ?
                                        <Link to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                        :
                                        <Link to='/izinpegawai/dinas.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                }
                                {' '}
                                <Button color="success" type="submit">
                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                </Button>
                            </Col>
                        </Row>
                    }

                </AvForm>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect && this.state.is_revisi != 1 ?
                    <Redirect to={`/izinpegawai/dinas.html`} />
                    : ""}

                {this.state.redirect && this.state.is_revisi == 1 ?
                    <Redirect to={`/kepegawaian/revisi_keuangan.html?create_revisi&uuid=` + this.state.period_revision_uuid + `&pegawai_uuid=` + this.state.revisi_pegawai_uuid} />
                    : ""}

            </Fragment>
        )
    }
}

export default ContentView;
export const CreateComponent = CreateView;